import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6e95b97d"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "w-[400px]"
};
var _hoisted_2 = {
  class: "text-gray-700 text-[22px] font-semibold mt-9"
};
var _hoisted_3 = {
  class: "mt-4 flex"
};
var _hoisted_4 = {
  class: "flex text-[13px] text-gray-600 mr-2"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 专辑：");

var _hoisted_6 = {
  class: "flex text-[13px] text-gray-600 mr-1"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 歌手：");

var _hoisted_8 = {
  key: 0,
  class: "cursor-pointer"
};
var _hoisted_9 = {
  key: 0,
  class: "lyric-item pb-5 text-sm text-gray-600 bg-opacity-5"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 歌词贡献者：");

var _hoisted_11 = {
  key: 1,
  class: "lyric-item pb-5 text-sm text-gray-600 bg-opacity-5"
};

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" 歌词贡献者：");

var _hoisted_13 = {
  key: 1,
  class: "flex items-center justify-center h-full text-sm text-gray-800"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _$props$song$album2;

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.song.name), 1
  /* TEXT */
  ), _withDirectives(_createElementVNode("div", {
    class: "mt-3 text-sm overflow-ellipsis whitespace-nowrap overflow-hidden"
  }, _toDisplayString($props.song.subName), 513
  /* TEXT, NEED_PATCH */
  ), [[_vShow, $props.song.subName]]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", {
    class: "text-blue-400 cursor-pointer w-24 overflow-ellipsis whitespace-nowrap overflow-hidden",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      var _$props$song$album;

      return $setup.gotoAlbumDetail((_$props$song$album = $props.song.album) === null || _$props$song$album === void 0 ? void 0 : _$props$song$album.id);
    })
  }, _toDisplayString((_$props$song$album2 = $props.song.album) === null || _$props$song$album2 === void 0 ? void 0 : _$props$song$album2.name), 1
  /* TEXT */
  )]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", {
    class: "text-blue-400 cursor-pointer w-24 overflow-ellipsis whitespace-nowrap overflow-hidden",
    title: "前往歌手详情",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.gotoArtistDetail($props.song.artists[0].id);
    })
  }, _toDisplayString($props.song.artists[0].name), 1
  /* TEXT */
  )])]), _createCommentVNode(" 歌词滚动 "), _createVNode(_component_el_scrollbar, {
    ref: "scrollBarRef",
    height: "380px",
    class: "h-80 w-[380px] mt-6 border-r border-solid border-gray-200"
  }, {
    default: _withCtx(function () {
      return [$setup.formatedLyrics && $setup.formatedLyrics.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formatedLyrics, function (lyric, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["lyric-item pb-5 text-sm text-gray-600 bg-opacity-5", $setup.lyricClass(lyric.text, index)])
        }, [_createElementVNode("div", null, _toDisplayString(lyric.text), 1
        /* TEXT */
        ), _createElementVNode("div", null, _toDisplayString(lyric.transText), 1
        /* TEXT */
        )], 2
        /* CLASS */
        );
      }), 128
      /* KEYED_FRAGMENT */
      )), _createCommentVNode(" 歌词贡献者 "), $props.lyricUser ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString($props.lyricUser.nickname), 1
      /* TEXT */
      )])) : _createCommentVNode("v-if", true), _createCommentVNode(" 歌词翻译贡献者 "), $props.transLyricUser ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString($props.transLyricUser.nickname), 1
      /* TEXT */
      )])) : _createCommentVNode("v-if", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_13, " 纯音乐，请您欣赏 "))];
    }),
    _: 1
    /* STABLE */

  }, 512
  /* NEED_PATCH */
  )]);
}